import { Modal } from "react-bootstrap";
import { Button } from "../button";
import { GenericForm } from "../generic-form";

import { CreateTaskModalProps } from "./CreateTaskModal.types";
import { useTranslation } from "react-i18next";

export const CreateTaskModal = ({
  isVisible,
  onDismiss,
  onSubmit,
  creating,
  createTaskForm,
}: CreateTaskModalProps) => {
  const { t } = useTranslation();
  return (
    <Modal show={isVisible} animation onHide={onDismiss}>
      <Modal.Header>
        <h5 className="modal-title" id="Dismiss Modal">
          {t("TASKS.CREATE_LABEL")}
        </h5>
        <div onClick={onDismiss}>
          <span className="font-20 cursor-pointer">&times;</span>
        </div>
      </Modal.Header>
      <Modal.Body>
        <GenericForm
          form={createTaskForm}
          onSubmit={onSubmit}
          submitControl={(submit) => (
            <div className="flex-row">
              <Button
                isLoading={creating}
                loader={{ size: "s" }}
                className="btn btn-primary mt-3 w-100"
                type="submit"
              >
                {t("CREATE_BUTTON")}
              </Button>
            </div>
          )}
        />
      </Modal.Body>
    </Modal>
  );
};
